#!/usr/bin/env node
import yargs from 'yargs'

// eslint-disable-next-line no-unused-expressions
yargs(process.argv.slice(2)).commandDir('commands').demandCommand().help().argv
